import React from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { Alert, Box, LinearProgress, Typography } from "@mui/material";
import { fetchWorkspaceTaskAnalytics } from "../../api/client";
import { TaskAnalyticsPanels } from "../TeamTasks/components/TaskAnalyticsPanels";

const DashboardTasksTab = ({ start, end }) => {
  const { t } = useTranslation("settings");
  const periodOk = Boolean(start && end && start <= end);
  const { data, isLoading, isFetching, error } = useQuery(
    ["dashboardTaskAnalytics", start, end],
    () => fetchWorkspaceTaskAnalytics({ start, end }),
    { enabled: periodOk, keepPreviousData: true }
  );
  const teamTasks = data?.teamTasks || null;
  const errMsg =
    (typeof error?.message === "string" && error.message) ||
    (error ? t("dashboardPage.tasksLoadError") : "");

  return (
    <Box sx={{ width: "100%", minWidth: 0 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2, maxWidth: 860 }}>
        {t("dashboardPage.tasksHint")}
      </Typography>
      {errMsg ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errMsg}
        </Alert>
      ) : null}
      {isFetching ? <LinearProgress sx={{ mb: 2 }} /> : null}
      <TaskAnalyticsPanels
        teamTasks={teamTasks}
        loading={isLoading && !teamTasks}
        variant="workspace"
      />
    </Box>
  );
};

export default DashboardTasksTab;
